// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__z6DDo","left":"styles_left__nGzPM"};